module.exports = __webpack_public_path__ + "static/services-ui-design-b504e2ee9bdd7a1b698200a91495ec52.svg";